import React, { useState } from 'react';

const useFilter = <T,>(initialState: T) => {
    const [formData, setFormData] = useState<T>(initialState);
    const handleChange = (event: React.ChangeEvent<{
        name?: string;
        value: unknown;
        type?: string;
        checked?: boolean;
    }>) => {
        const { value, name, type, checked } = event.target;
        if (name) {
            if (type !== 'checkbox') {
                setFormData({
                    ...formData,
                    [name]: value as string,
                });
            } else {
                setFormData({ ...formData, [name]: checked });
            }
        }
    };

    return {
        formData,
        handleChange,
        setFormData
    };
};

export default useFilter;
